import { ImportLog } from "./ImportLog";
import { Store } from "./Store";

export class ImportFile {
	fileName: string;
	size: number;
	presentedDateTime: Date;
	venueKey: number;
	checkDate: string;
	sizeReadable: string;

	Store: Store;

	ImportLog: ImportLog[];

	public constructor(init?: Partial<ImportFile>) {
		Object.assign(this, init);
		this.sizeReadable = this.formatBytes(this.size, 2);
	}

	formatBytes(bytes, decimals = 2) {
		if (bytes === 0) return "0 Bytes";

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
	}
}
